module.exports = __webpack_public_path__ + "Свинка.f0d40bf.png";